// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.weather-header-container {
  display: flex;
  align-items: center;
  padding: 5px 15px;
  /* background-color: #111; */
  color: white;
  border-radius: 4px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
  max-width: 400px;
}

.weather-header-container.clickable {
  cursor: pointer;
  transition: transform 0.2s ease, background-color 0.2s ease;
  position: relative;
  padding-right: 30px;
}

.weather-header-container.clickable:active {
  transform: translateY(0);
}

.weather-header-arrow {
  position: absolute;
  right: 12px;
  font-size: 24px;
  font-weight: 300;
  opacity: 0.7;
  transition: transform 0.2s ease;
}

.weather-header-container.clickable:hover .weather-header-arrow {
  transform: translateX(3px);
  opacity: 1;
}

.weather-header-icon {
  display: flex;
  align-items: center;
  margin-right: 10px;
  color: white;
  width: 24px;
  height: 24px;
}

.weather-header-temp {
  font-size: 20px;
  font-weight: 500;
  margin-right: 10px;
}

.weather-header-condition {
  font-size: 20px;
  opacity: 0.9;
}

.weather-header-loading,
.weather-header-error {
  padding: 10px;
  /* background-color: #111; */
  color: white;
  border-radius: 4px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
  max-width: 400px;
}

.weather-header-error {
  /* background-color: rgba(255, 0, 0, 0.1); */
  border-left: 3px solid red;
}

/* Responsive styles */
@media (max-width: 480px) {
  .weather-header-container {
    flex-wrap: wrap;
  }
  
  .weather-header-condition {
    width: 100%;
    margin-top: 5px;
    font-size: 16px;
  }
} 

.is-light .weather-header-container{
  color: #000;
}

.is-light .weather-header-container .weather-header-temp{
  color: #000;
}

.is-light .weather-header-container .weather-header-condition{
  color: #000;
}

.is-light .weather-header-container .weather-header-loading,
.is-light .weather-header-container .weather-header-error{
  color: #000;
}

.is-light .weather-header-container .weather-header-arrow{
  color: #000;
}

.is-light .weather-header-container .weather-header-icon{
  color: #000;
}


`, "",{"version":3,"sources":["webpack://./src/components/WeatherHeader.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,4BAA4B;EAC5B,YAAY;EACZ,kBAAkB;EAClB,gIAAgI;EAChI,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,2DAA2D;EAC3D,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;EAC1B,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;;EAEE,aAAa;EACb,4BAA4B;EAC5B,YAAY;EACZ,kBAAkB;EAClB,gIAAgI;EAChI,gBAAgB;AAClB;;AAEA;EACE,4CAA4C;EAC5C,0BAA0B;AAC5B;;AAEA,sBAAsB;AACtB;EACE;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,eAAe;EACjB;AACF;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb","sourcesContent":[".weather-header-container {\n  display: flex;\n  align-items: center;\n  padding: 5px 15px;\n  /* background-color: #111; */\n  color: white;\n  border-radius: 4px;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen-Sans, Ubuntu, Cantarell, \"Helvetica Neue\", sans-serif;\n  max-width: 400px;\n}\n\n.weather-header-container.clickable {\n  cursor: pointer;\n  transition: transform 0.2s ease, background-color 0.2s ease;\n  position: relative;\n  padding-right: 30px;\n}\n\n.weather-header-container.clickable:active {\n  transform: translateY(0);\n}\n\n.weather-header-arrow {\n  position: absolute;\n  right: 12px;\n  font-size: 24px;\n  font-weight: 300;\n  opacity: 0.7;\n  transition: transform 0.2s ease;\n}\n\n.weather-header-container.clickable:hover .weather-header-arrow {\n  transform: translateX(3px);\n  opacity: 1;\n}\n\n.weather-header-icon {\n  display: flex;\n  align-items: center;\n  margin-right: 10px;\n  color: white;\n  width: 24px;\n  height: 24px;\n}\n\n.weather-header-temp {\n  font-size: 20px;\n  font-weight: 500;\n  margin-right: 10px;\n}\n\n.weather-header-condition {\n  font-size: 20px;\n  opacity: 0.9;\n}\n\n.weather-header-loading,\n.weather-header-error {\n  padding: 10px;\n  /* background-color: #111; */\n  color: white;\n  border-radius: 4px;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen-Sans, Ubuntu, Cantarell, \"Helvetica Neue\", sans-serif;\n  max-width: 400px;\n}\n\n.weather-header-error {\n  /* background-color: rgba(255, 0, 0, 0.1); */\n  border-left: 3px solid red;\n}\n\n/* Responsive styles */\n@media (max-width: 480px) {\n  .weather-header-container {\n    flex-wrap: wrap;\n  }\n  \n  .weather-header-condition {\n    width: 100%;\n    margin-top: 5px;\n    font-size: 16px;\n  }\n} \n\n.is-light .weather-header-container{\n  color: #000;\n}\n\n.is-light .weather-header-container .weather-header-temp{\n  color: #000;\n}\n\n.is-light .weather-header-container .weather-header-condition{\n  color: #000;\n}\n\n.is-light .weather-header-container .weather-header-loading,\n.is-light .weather-header-container .weather-header-error{\n  color: #000;\n}\n\n.is-light .weather-header-container .weather-header-arrow{\n  color: #000;\n}\n\n.is-light .weather-header-container .weather-header-icon{\n  color: #000;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
